<template>
  <div class="create-order-page">
    <!-- 页面标题 / 返回按钮 -->
    <div class="page-header">
      <span class="title">要货申请</span>
    </div>

    <!-- 主体表单 -->
    <el-card class="form-card" shadow="never">
      <el-form :model="createForm" label-width="100px" size="small">
        <!-- 到货日期 & 销售点（销售点已注释） -->
        <el-row :gutter="20">
          <!-- <el-col :span="12">
            <el-form-item label="销售点" required>
              <el-select v-model="createForm.salesPoint" placeholder="请选择销售点" style="width:100%">
                <el-option v-for="item in salesPointList" :key="item.id" :label="item.name" :value="item.name" />
              </el-select>
            </el-form-item>
          </el-col> -->
          <el-col :span="12">
            <el-form-item label="到货日期" required>
              <el-date-picker v-model="createForm.arrivalDate" type="date" placeholder="选择到货日期" value-format="yyyy-MM-dd" style="width:100%" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="主批次号" required>
              <el-input v-model="createForm.batchNumber" placeholder="请输入批次号" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注">
              <el-input v-model="createForm.remark" placeholder="请输入备注" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 入库费用 -->
        <el-form-item label="入库费用">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-select v-model="feePaymentMethod" placeholder="支付方式" clearable>
                <el-option v-for="item in paymentMethodOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-select v-model="feeExpenseCategory" placeholder="支出类别" clearable>
                <el-option v-for="item in expenseCategoryOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-input v-model="feeAmount" placeholder="金额" type="number" />
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="addRelatedFee">添加费用</el-button>
            </el-col>
          </el-row>
          <div v-if="createForm.relatedFeesText && createForm.relatedFeesText !== '点击添加'" style="margin-top:6px;color:#409EFF;font-size:13px;">
            {{ createForm.relatedFeesText }}
          </div>
        </el-form-item>

        <!-- 已选货品列表 -->
        <el-form-item label="已选货品">
          <el-table :data="selectedGoods" border style="width:100%">
            <el-table-column prop="name" label="货品" min-width="100" show-overflow-tooltip />
            <el-table-column prop="mx_comlist_v1" label="规格" width="80" />
            <el-table-column prop="quantity" label="数量" width="80" />
            <el-table-column prop="weight" label="重量(斤)" width="100" />
            <el-table-column prop="purchasePrice" label="采购价" width="100">
              <template slot-scope="scope">¥{{ formatPrice(scope.row.purchasePrice) }}</template>
            </el-table-column>
            <el-table-column label="小计" width="110">
              <template slot-scope="scope"><span class="money">¥{{ (parseFloat(scope.row.quantity||0) * parseFloat(scope.row.purchasePrice||0)).toFixed(2) }}</span></template>
            </el-table-column>
            <el-table-column prop="ghs_name" label="供货商" width="100" show-overflow-tooltip />
            <el-table-column label="操作" width="140">
              <template slot-scope="scope">
                <el-button type="text" size="mini" @click="openEditGoods(scope.$index)">编辑</el-button>
                <el-button type="text" size="mini" style="color:#F56C6C;" @click="deleteGoods(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top:8px;">
            <el-button type="primary" size="small" icon="el-icon-plus" @click="openSelectGoods">添加货品</el-button>
            <span style="margin-left:12px;color:#999;font-size:13px;">共 {{ selectedGoods.length }} 件</span>
          </div>
        </el-form-item>

        <!-- 提交按钮 -->
        <el-form-item>
          <el-button type="primary" @click="submitInStock" :disabled="!isConfirmEnabled" :loading="submitLoading">确认要货</el-button>
          <el-button @click="goBack">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- ==================== 选择货品弹窗 ==================== -->
    <el-dialog title="选择货品" :visible.sync="selectGoodsDialogVisible" width="75%" :close-on-click-modal="false" @close="closeSelectGoods">
      <div style="margin-bottom:12px;">
        <el-row :gutter="10">
          <el-col :span="6">
            <el-select v-model="currentGroupId" placeholder="选择分组" clearable @change="fetchGoodsData" style="width:100%">
              <el-option v-for="g in groupList" :key="g.id" :label="g.name" :value="g.id" />
            </el-select>
          </el-col>
          <el-col :span="10">
            <el-input v-model="goodsSearchKeyword" placeholder="搜索货品名称" clearable @keyup.enter="fetchGoodsData" />
          </el-col>
          <el-col :span="4">
            <el-button type="primary" @click="fetchGoodsData">搜索</el-button>
            <el-button @click="goodsSearchKeyword='';fetchGoodsData()">重置</el-button>
          </el-col>
        </el-row>
      </div>

      <el-table v-loading="goodsLoading" :data="goodsList" border stripe style="width:100%">
        <el-table-column prop="goods_name" label="货品名称" min-width="140" show-overflow-tooltip />
        <el-table-column prop="comlist_v5" label="分组" width="150" show-overflow-tooltip />
        <el-table-column prop="comlist_v2" label="类目" width="150" show-overflow-tooltip />
        <el-table-column label="库存" width="150">
          <template slot-scope="scope">{{ getGoodsStock(scope.row) }}件</template>
        </el-table-column>
        <el-table-column label="规格" width="200">
          <template slot-scope="scope">
            <el-tag v-for="(spec, idx) in scope.row.specs" :key="idx" size="mini" style="margin:2px;">
              {{ spec.comlist_v1 }}
            </el-tag>
            <span v-if="!scope.row.specs || scope.row.specs.length===0" style="color:#999;">无规格</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="openGoodsDetail(scope.row)">选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @current-change="handleGoodsPageChange"
        :current-page="goodsPage"
        :page-size="goodsPageSize"
        layout="total, prev, pager, next"
        :total="goodsTotal"
        background
        small
      />
      <span slot="footer">
        <el-button @click="selectGoodsDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- ==================== 货品详情/编辑弹窗（选择货品时填写数量/价格） ==================== -->
    <el-dialog title="货品详情" :visible.sync="goodsDetailDialogVisible" width="450px" :close-on-click-modal="false" @close="resetGoodsDetail">
      <el-form :model="goodsDetailForm" label-width="90px" size="small">
        <el-form-item label="货品名称">
          <span>{{ goodsDetailForm.name }}</span>
        </el-form-item>
        <el-form-item label="规格">
          <el-select v-model="goodsDetailForm.specId" placeholder="请选择规格" @change="onSpecChange">
            <el-option v-for="s in goodsDetailForm.specs" :key="s.id" :label="s.comlist_v1" :value="s.id" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="供货商">
          <el-select v-model="goodsDetailForm.supplierId" placeholder="选择供货商" filterable>
            <el-option v-for="s in supplierList" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </el-form-item> -->
        <el-form-item label="数量(件)">
          <el-input-number v-model="goodsDetailForm.quantity" :min="0" :precision="0" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="重量(斤)">
          <el-input-number v-model="goodsDetailForm.weight" :min="0" :precision="2" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="采购价(元/件)">
          <el-input-number v-model="goodsDetailForm.purchasePrice" :min="0" :precision="2" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="小计">
          <span class="money">¥{{ (goodsDetailForm.quantity * goodsDetailForm.purchasePrice).toFixed(2) }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="goodsDetailDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmGoodsDetail">确认添加</el-button>
      </span>
    </el-dialog>

    <!-- ==================== 编辑已选货品弹窗（创建入库单中编辑） ==================== -->
    <el-dialog title="编辑货品" :visible.sync="editSelectedGoodsDialogVisible" width="450px" :close-on-click-modal="false">
      <el-form :model="editSelectedForm" label-width="90px" size="small">
        <el-form-item label="货品">
          <span>{{ editSelectedForm.name }}({{ editSelectedForm.mx_comlist_v1 }})</span>
        </el-form-item>
        <!-- <el-form-item label="供货商">
          <el-select v-model="editSelectedForm.ghs_id" placeholder="选择供货商" filterable>
            <el-option v-for="s in supplierList" :key="s.id" :label="s.name" :value="s.id" />
          </el-select>
        </el-form-item> -->
        <el-form-item label="数量(件)">
          <el-input-number v-model="editSelectedForm.quantity" :min="0" :precision="0" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="重量(斤)">
          <el-input-number v-model="editSelectedForm.weight" :min="0" :precision="2" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="采购价(元/件)">
          <el-input-number v-model="editSelectedForm.purchasePrice" :min="0" :precision="2" controls-position="right" style="width:100%" />
        </el-form-item>
        <el-form-item label="小计">
          <span class="money">¥{{ (editSelectedForm.quantity * editSelectedForm.purchasePrice).toFixed(2) }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editSelectedGoodsDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmEditSelectedGoods">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'CreateOrder',
  data () {
    return {
      // 表单数据
      createForm: {
        salesPoint: '默认销售点',
        arrivalDate: this.formatDate(new Date()),
        batchNumber: '',
        remark: '',
        relatedFeesText: '点击添加'
      },
      salesPointList: [],
      selectedGoods: [],
      feePaymentMethod: '',
      feeExpenseCategory: '',
      feeAmount: '',
      paymentMethodOptions: ['现金', '银行卡', '个人微信', '个人支付宝'],
      expenseCategoryOptions: ['手续费', '卸车费', '运费', '三轮费'],
      feeType: '',
      feeAmountVal: 0,

      // 提交状态
      submitLoading: false,

      // 选择货品
      selectGoodsDialogVisible: false,
      goodsLoading: false,
      goodsList: [],
      goodsPage: 1,
      goodsPageSize: 10,
      goodsTotal: 0,
      groupList: [],
      currentGroupId: null,
      goodsSearchKeyword: '',

      // 货品详情（选择时填写）
      goodsDetailDialogVisible: false,
      goodsDetailForm: {
        id: null,
        name: '',
        specs: [],
        specId: null,
        supplierId: null,
        quantity: 1,
        weight: 0,
        purchasePrice: 0
      },
      supplierList: [],

      // 编辑已选货品
      editSelectedGoodsDialogVisible: false,
      editSelectedIndex: -1,
      editSelectedForm: {
        name: '',
        mx_comlist_v1: '',
        ghs_id: null,
        quantity: 0,
        weight: 0,
        purchasePrice: 0
      },

      // 批次号计数
      piciNum: 0
    }
  },

  computed: {
    isConfirmEnabled () {
      return !!(
        this.createForm.arrivalDate &&
        this.createForm.batchNumber &&
        this.selectedGoods.length > 0
      )
    }
  },

  mounted () {
    this.initData()
  },

  methods: {
    // ---------- 工具 ----------
    formatDate (date) {
      if (!date) return ''
      const d = new Date(date)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    formatPrice (val) {
      const num = parseFloat(val)
      return isNaN(num) ? '0.00' : num.toFixed(2)
    },

    // ---------- 初始化 ----------
    async initData () {
      await Promise.all([
        this.getSalesPointList(),
        this.getSupplierList(),
        this.getGroupList(),
        this.getPiciNum()
      ])
      // 设置默认销售点
      if (this.salesPointList.length > 0) {
        this.createForm.salesPoint = this.salesPointList[0].name
      }
      // 生成批次号
      this.generateBatchNumber()
    },

    // ---------- 获取基础数据 ----------
    async getSalesPointList () {
      try {
        const shopId = localStorage.getItem('sh_id')
        const userType = localStorage.getItem('user_type')
        const res = await request.post('/goods/salespoint_list.php', {
          sh_id: shopId,
          user_type: userType
        })
        if (res.code === 0) {
          this.salesPointList = res.pointList || []
        }
      } catch (e) {
        console.error('获取销售点失败', e)
      }
    },

    async getSupplierList () {
      try {
        const shId = localStorage.getItem('sh_id')
        const res = await request.post('/goods/goods_com_list.php', { shId })
        if (res.com_list) {
          this.supplierList = res.com_list.map(item => ({
            id: item.id,
            name: item.comlist_v1
          }))
        }
      } catch (e) {
        console.error('获取供货商列表失败', e)
      }
    },

    async getGroupList () {
      try {
        const shopId = localStorage.getItem('sh_id')
        const res = await request.post(
          '/goods/fenzu_jiben_list.php',
          { bfenlei1: shopId }
        )
        if (res.code === 0 && Array.isArray(res.fenzuList)) {
          this.groupList = res.fenzuList.map(item => ({
            id: item.id,
            name: item.bfenlei4
          }))
          if (this.groupList.length > 0) {
            this.currentGroupId = this.groupList[0].id
          }
        }
      } catch (e) {
        console.error('获取分组列表失败', e)
      }
    },

    async getPiciNum () {
      try {
        const shId = localStorage.getItem('sh_id')
        const res = await request.post('/goods/get_pici_num.php', { shId })
        this.piciNum = res.pici_num || 0
        this.generateBatchNumber()
      } catch (e) {
        console.error('获取批次号失败', e)
      }
    },

    generateBatchNumber () {
      const now = new Date()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      this.createForm.batchNumber = `${month}-${day}-第${this.piciNum || 0}批`
    },

    // ---------- 费用添加 ----------
    addRelatedFee () {
      if (!this.feePaymentMethod || !this.feeExpenseCategory || !this.feeAmount || parseFloat(this.feeAmount) <= 0) {
        this.$message.warning('请完整填写支付方式、支出类别和金额')
        return
      }
      this.feeType = this.feeExpenseCategory
      this.feeAmountVal = parseFloat(this.feeAmount)
      this.createForm.relatedFeesText = `已添加费用（${this.feePaymentMethod} ${this.feeExpenseCategory}：${this.feeAmount}元）`
      this.$message.success('费用已添加')
    },

    // ---------- 选择货品 ----------
    openSelectGoods () {
      this.selectGoodsDialogVisible = true
      this.goodsPage = 1
      this.fetchGoodsData()
    },

    closeSelectGoods () {
      this.selectGoodsDialogVisible = false
    },

    async fetchGoodsData () {
      this.goodsLoading = true
      try {
        const params = {
          a: 'jxGoodsList',
          jx_id: localStorage.getItem('jx_id'),
          page: this.goodsPage,
          page_size: this.goodsPageSize
        }
        if (this.goodsSearchKeyword && this.goodsSearchKeyword.trim()) {
          params.goods_name = this.goodsSearchKeyword.trim()
        }
        const res = await request.post('/admin/jx_goods.php', params)
        if (res.code === '0') {
          this.goodsList = res.data.map(item => {
            return {
              ...item,
              goods_id: item.id,
              goods_name: item.comlist_v1 || '',
              goods_mx: item.goods_mx || [],
              total_stock: item.specs.reduce((sum, s) => sum + s.comlist_s1, 0)
            }
          })
          this.goodsTotal = this.goodsList.length
        } else {
          this.goodsList = []
          this.goodsTotal = 0
        }
      } catch (e) {
        console.error('获取货品列表失败', e)
        this.$message.error('获取货品列表失败')
      } finally {
        this.goodsLoading = false
      }
    },

    handleGoodsPageChange (val) {
      this.goodsPage = val
      this.fetchGoodsData()
    },

    getGoodsStock (row) {
      if (row.specs && row.specs.length > 0) {
        return row.specs.reduce((sum, s) => sum + Number(s.comlist_s1), 0)
      }
      return row.total_stock || 0
    },

    // ---------- 货品详情（添加） ----------
    openGoodsDetail (goods) {
      const specs = goods.specs || []
      this.goodsDetailForm = {
        id: goods.goods_id,
        name: goods.goods_name,
        specs: specs,
        specId: specs.length > 0 ? specs[0].id : null,
        supplierId: null,
        quantity: 1,
        weight: 0,
        purchasePrice: specs.length > 0 ? specs[0].comlist_f2 : 0
      }
      if (this.supplierList.length > 0) {
        this.goodsDetailForm.supplierId = this.supplierList[0].id
      }
      this.goodsDetailDialogVisible = true
    },

    resetGoodsDetail () {
      this.goodsDetailForm = {
        id: null,
        name: '',
        specs: [],
        specId: null,
        supplierId: null,
        quantity: 1,
        weight: 0,
        purchasePrice: 0
      }
    },

    onSpecChange (specId) {
      const spec = this.goodsDetailForm.specs.find(s => s.id === specId)
      if (spec) {
        this.goodsDetailForm.purchasePrice = spec.comlist_f2 || 0
      }
    },

    confirmGoodsDetail () {
      const form = this.goodsDetailForm
      if (!form.specId) {
        this.$message.warning('请选择规格')
        return
      }
      if (form.quantity <= 0) {
        this.$message.warning('数量必须大于0')
        return
      }
      if (form.purchasePrice < 0) {
        this.$message.warning('采购价不能为负数')
        return
      }

      const spec = form.specs.find(s => s.id === form.specId)
      const supplier = this.supplierList.find(s => s.id === form.supplierId)

      // 检查是否已添加相同货品+规格
      const existIdx = this.selectedGoods.findIndex(
        item => item.id === form.id && item.mx_id === form.specId
      )
      if (existIdx >= 0) {
        this.$message.warning('该货品规格已添加，请编辑或删除后重试')
        return
      }

      this.selectedGoods.push({
        id: form.id,
        name: form.name,
        mx_id: form.specId,
        mx_comlist_v1: spec ? spec.comlist_v1 : '',
        quantity: form.quantity,
        weight: form.weight || 0,
        purchasePrice: form.purchasePrice,
        ghs_id: form.supplierId,
        ghs_name: supplier ? supplier.name : ''
      })

      this.$message.success('添加成功')
      this.goodsDetailDialogVisible = false
    },

    // ---------- 编辑已选货品 ----------
    openEditGoods (index) {
      const item = this.selectedGoods[index]
      if (!item) return
      this.editSelectedIndex = index
      this.editSelectedForm = {
        name: item.name,
        mx_comlist_v1: item.mx_comlist_v1 || '',
        ghs_id: item.ghs_id || null,
        quantity: item.quantity,
        weight: item.weight || 0,
        purchasePrice: item.purchasePrice
      }
      this.editSelectedGoodsDialogVisible = true
    },

    confirmEditSelectedGoods () {
      const idx = this.editSelectedIndex
      if (idx < 0 || idx >= this.selectedGoods.length) return
      const form = this.editSelectedForm
      if (form.quantity <= 0) {
        this.$message.warning('数量必须大于0')
        return
      }
      if (form.purchasePrice < 0) {
        this.$message.warning('采购价不能为负数')
        return
      }
      const supplier = this.supplierList.find(s => s.id === form.ghs_id)
      this.selectedGoods[idx] = {
        ...this.selectedGoods[idx],
        quantity: form.quantity,
        weight: form.weight || 0,
        purchasePrice: form.purchasePrice,
        ghs_id: form.ghs_id,
        ghs_name: supplier ? supplier.name : ''
      }
      this.editSelectedGoodsDialogVisible = false
      this.$message.success('更新成功')
    },

    deleteGoods (index) {
      this.$confirm('确定删除该货品吗？', '提示', { type: 'warning' }).then(() => {
        this.selectedGoods.splice(index, 1)
        this.$message.success('已删除')
      }).catch(() => {})
    },

    // ---------- 提交入库 ----------
    async submitInStock () {
      if (!this.isConfirmEnabled) return
      this.submitLoading = true
      try {
        const shopId = localStorage.getItem('sh_id')
        const userName = localStorage.getItem('user_name')
        const userId = localStorage.getItem('user_id')
        const workId = localStorage.getItem('work_id')

        const goodsList = this.selectedGoods.map(item => ({
          goods_id: item.id,
          goods_name: item.name,
          mx_id: item.mx_id,
          mx_comlist_v1: item.mx_comlist_v1 || '',
          comlist_s1: item.quantity,
          comlist_v6: item.weight || 0,
          comlist_f1: item.purchasePrice,
          ghs_id: item.ghs_id || '',
          ghs_name: item.ghs_name || ''
        }))

        const submitData = {
          user_name: userName || '',
          sales_point: this.createForm.salesPoint || '销售点',
          arrival_date: this.createForm.arrivalDate,
          batch_number: this.createForm.batchNumber,
          remark: this.createForm.remark || '',
          comlist_v4: this.feeType || '',
          comlist_v5: this.feeAmountVal || 0,
          goods_list: JSON.stringify(goodsList),
          jx_id: shopId || '',
          user_id: userId || '',
          work_id: workId || ''
        }

        const res = await request.post('/ht/yaohuo_in_add.php', submitData)

        if (res.code === 0) {
          this.$message.success('申请成功')
          // 跳回列表页，并携带刷新标识
          // this.$router.push({ path: '/order', query: { refresh: Date.now() } })
        } else {
          this.$message.error(res.msg || '入库失败')
        }
      } catch (e) {
        console.error('提交入库失败', e)
        this.$message.error('网络错误，请重试')
      } finally {
        this.submitLoading = false
      }
    },

    // ---------- 返回 ----------
    goBack () {
      this.$router.push('/order')
    }
  }
}
</script>

<style lang="scss" scoped>
.create-order-page {
  padding: 20px;
  background-color: #f0f2f6;
  min-height: 100vh;

  .page-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .title {
      font-size: 18px;
      font-weight: 600;
      margin-left: 12px;
    }
  }

  .form-card {
    // max-width: 1200px;
    .money {
      color: #ee530c;
      font-weight: 600;
    }
    .pagination {
      margin-top: 16px;
      text-align: right;
    }
  }
}
</style>
